import {
    SET_STAGE,
    SET_SELECTED_BET,
    SET_RESULT,
    SET_BATTLE_PLAYERS,
} from './constants'

export const setStage = (payload) => (dispatch) => {
    dispatch({
        type: SET_STAGE,
        payload: payload,
    })
}

export const setSelectedBet = (payload) => (dispatch) => {
    dispatch({
        type: SET_SELECTED_BET,
        payload: payload,
    })
}

export const setResult = (payload) => (dispatch) => {
    dispatch({
        type: SET_RESULT,
        payload: payload,
    })
}

export const setBattlePlayers = (payload) => (dispatch) => {
    dispatch({
        type: SET_BATTLE_PLAYERS,
        payload: payload,
    })
}
